const Immersive3dTourPropertyType = {
  RESIDENTIAL: 0,
  COMMERCIAL: 1,
};

export default Immersive3dTourPropertyType;
